/**
 * Site-only layout width tokens: withLayout column modes and default content max width.
 */
export const SITE_LAYOUT = Object.freeze({
  contentMaxWidth: 1100,
  layoutContentWide: 1200,
  layoutContentMd: 940,
  layoutContentSm: 640,
} as const);

export type SiteLayoutWidths = typeof SITE_LAYOUT;
